import RequestService from './request';

export interface LoadingScreenResponse {
    url: string;
    status?: string;
    mustLinkDiscord: boolean;
}

export class LoadingScreenService {
    get(): Promise<LoadingScreenResponse> {
        return RequestService.post('/servers/:server/loading-screen');
    }
}

export default new LoadingScreenService();
